import { Download, Forward, Heart } from "lucide-react";
import { cn } from "@/lib/utils";
import type { LightboxShareLikeRowProps } from "./types";

export function LightboxShareLikeRow({
  onDownload,
  downloadLabel,
  onShare,
  shareLabel,
  liked,
  onToggleLike,
}: LightboxShareLikeRowProps) {
  return (
    <div className="grid grid-cols-[1fr_1fr_auto] md:grid-cols-[1fr_auto] gap-2">
      {onDownload && (
        <button
          onClick={onDownload}
          className="md:col-span-2 flex items-center justify-center gap-2 py-2.5 md:py-3 px-2 rounded-xl md:rounded-2xl bg-green-500/15 hover:bg-green-500/25 text-foreground font-bold transition-all active:scale-95"
        >
          <Download className="w-4 h-4 text-green-400" />
          <span className="text-xs md:text-sm">{downloadLabel}</span>
        </button>
      )}
      <button
        onClick={onShare}
        className="flex items-center justify-center gap-2 py-2.5 md:py-3 px-2 rounded-xl md:rounded-2xl bg-blue-500/10 hover:bg-blue-500/20 text-foreground font-bold transition-all active:scale-95"
      >
        <Forward className="w-4 h-4 text-blue-400" />
        <span className="text-xs md:text-sm">{shareLabel}</span>
      </button>
      <button
        onClick={onToggleLike}
        className={cn(
          "flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-xl md:rounded-2xl transition-all active:scale-95",
          liked
            ? "bg-red-500 text-white hover:bg-red-600"
            : "bg-red-500/10 text-red-400 hover:bg-red-500/20"
        )}
      >
        <Heart className={cn("w-5 h-5", liked && "fill-current")} />
      </button>
    </div>
  );
}
